import React from "react";
import { IoLogoWhatsapp } from "react-icons/io";
import { MdEmail } from "react-icons/md";

const Footer = () => {
  const companyLinks = [
    { name: "About Us", href: "/About" },
    { name: "Contact Us", href: "/contact-us" },
    { name: "Why Us", href: "/why-us" },
    { name: "Our Services", href: "/Service" },
    { name: "Showcase", href: "/showcase" },
    { name: "Privacy Policy", href: "/privacy-policy" },
  ];

  return (
    <footer className="bg-gray-900 mt-8 text-white py-8">
      <div className="max-w-screen-xl mx-auto px-6">
        {/* Top Row */}
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-6 mb-6">
          {/* Left: Links */}
          <div className="flex flex-col sm:flex-row gap-12">
            {/* Company Links */}
            <div>
            <h3 className="text-lg font-semibold mb-2">Help Desk</h3>
              <ul className="flex gap-2">
                {companyLinks.map((link) => (
                  <li key={link.name}>
                    <a
                      className="text-sm text-gray-300 hover:text-white transition duration-200"
                      href={link.href}
                    >
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Services Links */}
          
          </div>

          {/* Right: Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-2">Get in Touch</h3>
            <ul className=" flex gap-2 justify-center align-center">
              {/* WhatsApp Link */}
              <li className="flex gap-1 items-center text-sm text-gray-300">
              <IoLogoWhatsapp />
                <a
                  href="https://wa.me/393508616907"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-white"
                >
                  +393508616907
                </a>
              </li>

              <li className="flex gap-1 items-center text-sm text-gray-300">
               <MdEmail />
                <a
                  href="mailto:contact@werkeon.com"
                  className="hover:text-white"
                >
                  contact@werkeon.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Row: Centered Copyright */}
        <div className="border-t border-gray-700 pt-4 text-center">
          <p className="text-sm text-gray-400">
            &copy; {new Date().getFullYear()} werkeon. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
